define.alias("shared/components/shared/stop-the-world-modal", "media/components/shared/stop-the-world-modal");